module.exports = "<div ng-hide=\"true\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/slider.html
// module id = 198
// module chunks = 0